module.exports = __webpack_public_path__ + "img/blue_background.a9b45e0b.jpg";